import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";

class Folder extends SmartModel {
	code = "";//Dave: A che serve???
	clientGuid = "";
	createdAt = "0000-00-00 00:00:00";
	createdByGuid = "";
	guid = "";
	name = "";
	ownerGuid = "";
	parentGuid = "";
	parentGuids = [];
	referenceGuid = "";
	referenceType = "";
	status = 0;
	type = "";
	updatedAt = "0000-00-00 00:00:00";
	updatedByGuid = "";

	sisRegistry = {};

	__active = false;
	__cssClass = "";
	__ownerLabelForBreadCrumb = "";
	__ownerName = "";
	__roleInParentLabel = "";
	__showOnwerActions = false;
	__showOwnerName = false;
	__userIsOwner = false;

	constructor(data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportedData = this.__export();

		exportedData.createdAt = moment.utc(this.createdAt).format("YYYY-MM-DD HH:mm:ss");
		exportedData.status = parseInt(this.status);
		exportedData.updatedAt = moment.utc(this.updatedAt).format("YYYY-MM-DD HH:mm:ss");

		exportedData.parentGuids = this.exportArrayField("parentGuids");

		return exportedData;
	}

	evaluateRoleInParent () {
		if (this.parentGuids.length > 0) {
			const documentsFolderBreadCrumb = Shark.get("documentsFolderBreadCrumb");
			
			if (documentsFolderBreadCrumb) {
				const currFolder = documentsFolderBreadCrumb[documentsFolderBreadCrumb.length - 1];
				
				if (currFolder) {
					for (let currParent of this.parentGuids) {
						if (currParent.guid === currFolder.guid) {
							this.__roleInParent = currParent.roleInParent;

							switch (currParent.roleInParent) {
								case "customer":
									this.__roleInParentLabel = "Committente";
									break;
								case "designer":
									this.__roleInParentLabel = "Progettista";
									break;
								case "endUser":
									this.__roleInParentLabel = "Utilizzatore Finale";
									break;
							}

							break;
						}
					}
				}
			}
		}
	}

	import (data, options) {
		this.__import(data, options);

		if (this.importDateField("createdAt", data.createdAt)) {
			this.__createdAt = this.createdAt.format("YYYY-MM-DD");
			this.__createdAtLabel = this.createdAt.format("DD/MM/YY - HH:mm");
		}

		this.importNumberField("status", data.status);

		if (this.importDateField("updatedAt", data.updatedAt)) {
			this.__updatedAt = this.updatedAt.format("YYYY-MM-DD");
			this.__updatedAtLabel = this.updatedAt.format("DD/MM/YY - HH:mm");
		}

		this.evaluateRoleInParent();
		this.parseOwner();

		if (this.type === "clients" || this.type === "documents" || this.type === "userDocuments") {
			this.__ownerLabelForBreadCrumb = !this.__userIsOwner ? " <small>(" + this.__ownerName + ")</small>" : "";
		}
		this.__showOnwerActions = ["client", "clients", "constructionSite", "notComplianceReport", "siteInfoSheet", "siteInspection", "userDocuments"].indexOf(this.type) === -1 && this.__userIsOwner;
		this.__cssClass = !this.__showOnwerActions || this.__ownerName === "IPM" ? "primary" : "info";

		this.parseSISRegistry();
	}

	parseOwner () {
		const currUser = Shark.get("currUser");


		const userList = Shark.get("userList");

		if (userList) {
			if (this.ownerGuid !== "") {
				const user = Utils.safp(userList, "guid", this.ownerGuid);
				
				if (user) {
					this.__ownerName = user.__fullName;
				}
			}
			else {
				this.__ownerName = "IPM";
			}
		}
		else {
			this.__ownerName = "N/D";
		}
		this.__showOwnerName = true;

		this.__userIsOwner = this.ownerGuid === currUser.guid;
	}

	parseSISRegistry() {
		if (this.sisRegistry) {
			this.__customerName = this.sisRegistry.customerName;
			this.__designerName = this.sisRegistry.designerName;
			this.__endUserName = this.sisRegistry.endUserName;

			this.__showAllUserBox = this.__customerName || this.__designerName || this.__endUserName;
		}
	}
}

Shark.registerModel("Folder", Folder);

export default Folder;